import { Device, breakpoints } from '@secretescapes/falcon';

export const mediaQuery = {
  mobile: `(max-width: ${breakpoints[Device.tablet]})`,
  tablet: `(min-width: ${breakpoints[Device.tablet]}) and (max-width: ${
    breakpoints[Device.desktop]
  })`,
  desktop: `(min-width: ${breakpoints[Device.desktop]})`,
};

export interface CommonStyledProps {
  isMobile?: boolean;
}
